import { PaginasMenuAttributes } from "@fl/shared/src/types/models/suporte_fl/paginas_menus";
import React, { createContext, useContext, useEffect, useState } from "react";
import StorageItems, { IKeys } from "../storage";

interface IMenuContext {
  menus: PaginasMenuAttributes[];
  setMenus: (menus: PaginasMenuAttributes[]) => void;
}

const MenuContext = createContext<IMenuContext>({
  menus: [],
  setMenus: () => {},
});

export const useMenuContext = () => useContext(MenuContext);

const storage = new StorageItems();
const STORAGE_KEY: IKeys = "menus";

export const MenuProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [menus, setMenus] = useState<PaginasMenuAttributes[]>(
    storage.get(STORAGE_KEY) || []
  );

  useEffect(() => {
    storage.set(STORAGE_KEY, menus); // Sincroniza menus no localStorage sempre que mudarem
  }, [menus]);

  return (
    <MenuContext.Provider value={{ menus, setMenus }}>
      {children}
    </MenuContext.Provider>
  );
};
